import {Dialog} from '@primer/react/experimental'
import {Text} from '@primer/react'
import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {useEffect} from 'react'

export type BranchNextStepDesktopProps = {
  branch: string | null
  repository: string
  owner: string
  onClose: () => void
}

export const BranchNextStepDesktop = ({branch, repository, owner, onClose}: BranchNextStepDesktopProps) => {
  const desktopUrl = `x-github-client://openRepo/https://${ssrSafeWindow?.origin}/${owner}/${repository}?${branch}`

  useEffect(() => {
    if (ssrSafeWindow) {
      ssrSafeWindow.location.replace(desktopUrl)
    }
  }, [desktopUrl])

  return (
    <Dialog width="large" height="auto" title={'Opening branch in GitHub Desktop...'} onClose={onClose}>
      <Text
        sx={{
          color: 'fg.muted',
          fontSize: 12,
        }}
      >
        If nothing happens, make sure{' '}
        <a target="_blank" href="https://desktop.github.com/" rel="noreferrer">
          GitHub Desktop
        </a>{' '}
        is installed and set up properly, then <a href={desktopUrl}>try again</a>.
      </Text>
    </Dialog>
  )
}

try{ BranchNextStepDesktop.displayName ||= 'BranchNextStepDesktop' } catch {}